import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import AdminLayout from "../components/AdminLayout";
import { FISP_TV_ADMIN_HOME_PATH } from "../config";
import { getFispTvAdminFallbackPath, isFispTvAdminAuthenticated, setFispTvAdminAuthenticated } from "../session";
import { loginAdminUser } from "../api";
import useNewsAdminServer from "../hooks/useNewsAdminServer";

export default function FispTvAdminLogin() {
    const location = useLocation();
    const navigate = useNavigate();
    const { server, serverResolved } = useNewsAdminServer();
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        setError("");
    }, [password]);

    if (isFispTvAdminAuthenticated()) {
        return <Navigate to={FISP_TV_ADMIN_HOME_PATH} replace />;
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        setSubmitting(true);
        setError("");

        try {
            await loginAdminUser(password, server);
            setFispTvAdminAuthenticated();
            const nextPath = location.state?.from || getFispTvAdminFallbackPath();
            navigate(nextPath, { replace: true });
        } catch {
            setError("La contraseña no coincide. Probá nuevamente.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <AdminLayout showNavLinks={false} centered={true}>
            <section className="tv-admin-login-stage">
                <form className="tv-admin-login-card tv-admin-login-form" onSubmit={handleSubmit}>
                    <label htmlFor="tv-admin-password">Contraseña</label>
                    <input
                        id="tv-admin-password"
                        type="password"
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                        placeholder="Ingresar contraseña"
                        autoComplete="current-password"
                        autoFocus
                        required
                    />

                    {error ? <p className="tv-admin-error">{error}</p> : null}

                    <button type="submit" className="tv-admin-primary-btn" disabled={!serverResolved || submitting}>
                        {submitting ? "Ingresando..." : "Ingresar"}
                    </button>
                </form>
            </section>
        </AdminLayout>
    );
}